export default __webpack_public_path__ + "locales/az/DeleteProfileEverDialog.json?hash=e611b3db422bc7092b6e19089a231765";